import type { ExtranetIncidentOutput } from '../../types/extranet-api.types';

/**
 * Le back livre un shape dédié extranet : les champs se lisent directement.
 * Seule la date demande une conversion, `createdAt` étant une chaîne ISO alors
 * que les formateurs et le tri travaillent en millisecondes.
 */
export const getIncidentCreatedAtMs = (incident: ExtranetIncidentOutput): number => {
  const ts = Date.parse(incident.createdAt);
  return Number.isNaN(ts) ? 0 : ts;
};
